import camelcaseKeys from 'camelcase-keys';
import CalendarEventsAPI from 'dashboard/api/calendarEvents';
import ContactAPI from 'dashboard/api/contacts';
import { createStore } from 'dashboard/store/storeFactory';
import { throwErrorMessage } from 'dashboard/store/utils/api';

export const useCalendarEventsStore = createStore({
  name: 'calendarEvents',
  type: 'pinia',
  API: CalendarEventsAPI,

  actions: () => ({
    async fetchRange(since, until) {
      this.setUIFlag({ fetchingList: true });
      try {
        const {
          data: { payload },
        } = await CalendarEventsAPI.get(since, until);
        this.records = camelcaseKeys(payload || [], { deep: true });
        return this.records;
      } catch (error) {
        return throwErrorMessage(error);
      } finally {
        this.setUIFlag({ fetchingList: false });
      }
    },

    async moveContactAttributeEvent({
      eventId,
      contactId,
      attributeKey,
      newDate,
    }) {
      const previousRecords = this.records;
      this.records = previousRecords.map(record =>
        record.id === eventId ? { ...record, startsAt: newDate } : record
      );
      try {
        await ContactAPI.update(contactId, {
          custom_attributes: { [attributeKey]: newDate },
        });
      } catch (error) {
        this.records = previousRecords;
        return throwErrorMessage(error);
      }
      return this.records;
    },
  }),
});
